import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ShowRoomService } from 'src/app/services/showroom/showroom.service';
import { ModalIotFilterComponent } from 'src/app/shared/components/modals/showroom/modal-iot-filter/modal-iot-filter.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import {Chart} from 'chart.js';

@Component({
  selector: 'app-showroom-iot',
  templateUrl: './showroom-iot.component.html',
  styleUrls: ['./showroom-iot.component.css']
})
export class ShowroomIotComponent implements OnInit {
  actuators = [];
  sensors = [];
  labels = [];
  showPanel = false;
  optionFilter = 0;
  colors = [['#e5f6ff', '#82cfff'],["#1f4037","#99f2c8"],["#f12711","#f5af19"],["#FDC830","#F37335"],["#7F7FD5","#86A8E7","#91EAE4"]];
  colorsArray = ['#e5f6ff',"#99f2c8","#f5af19","#F37335","#91EAE4"];

  constructor(
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public showroomService: ShowRoomService
    ) { }

  ngOnInit(): void {
    this.getListActuators();
    this.getListSensors();
  }
/*
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }
*/

  getListSensors(){
    /*this.labels = ['10/10/2022 09:10','10/10/2022 09:30','10/10/2022 09:50','10/10/2022 10:10','15/10/2022 10:10'];
    var data = "[{\"id\": 1, \"name\": \"Velocidad de Faja\", \"values\": [1,2,3,5,6]}, {\"id\": 2, \"name\": \"Velocidad de Faja 2 \", \"values\": [1,2,3,5,6]},{\"id\": 3, \"name\": \"Velocidad de Faja 3\", \"values\": [1,2,3,5,6]},{\"id\": 4, \"name\": \"Velocidad de Faja 4\", \"values\": [1,2,3,5,6]}]";
    this.sensors = JSON.parse(data);*/
    this.showroomService.getListSensors().subscribe((_) => {
      var sensors = _.data;
      sensors.filter(_ => {
        _.idCanvas = _.id * Math.floor(Date.now() / 1000)
        _.color = this.colorsArray[Math.floor(Math.random() * this.colorsArray.length)];
      });
      this.sensors = sensors;

      console.log(this.sensors);
    });
  }

  getListActuators(){
    this.spinner.show();
    /*var data = "[{\"id\": 1, \"maxLimit\": 255, \"name\": \"Velocidad de Faja\", \"stepLength\": 0, \"stepOptions\": \"\", \"type\": 3, \"update\": 0, \"value\": 50}, {\"id\": 2, \"maxLimit\": 255, \"name\": \"Velocidad de centrífuga\", \"stepLength\": 0, \"stepOptions\": \"\", \"type\": 3, \"update\": 0, \"value\": 15}, {\"id\": 3, \"maxLimit\": null, \"name\": \"Válvula Angular\", \"stepLength\": 5, \"stepOptions\": \"0,25,50,75,90\", \"type\": 5, \"update\": 0, \"value\": 90.0}, {\"id\": 4, \"maxLimit\": null, \"name\": \"Resistencia\", \"stepLength\": null, \"stepOptions\": null, \"type\": 2, \"update\": 0, \"value\": 0.0}, {\"id\": 5, \"maxLimit\": null, \"name\": \"Iniciar Bombeo\", \"stepLength\": null, \"stepOptions\": null, \"type\": 2, \"update\": 0, \"value\": 1}, {\"id\": 6, \"maxLimit\": null, \"name\": \"Iniciar Showroom\", \"stepLength\": null, \"stepOptions\": null, \"type\": 1, \"update\": 0, \"value\": 0.0}, {\"id\": 7, \"maxLimit\": null, \"name\": \"Detener Showroom\", \"stepLength\": null, \"stepOptions\": null, \"type\": 1, \"update\": 0, \"value\": 1.0}]";
    this.actuators = JSON.parse(data);
    var i = 0;
    this.actuators.filter(_ => {
        if(_.id != 6 && _.id != 7 && _.type != 2){
          if(_.type==3){
            _.value = _.value;
            //document.getElementById("value-slider"+_.id).innerHTML = _.value.toString() + "%";
          }else if(_.type==5){
            var array = _.stepOptions.split(",");
            _.value =array.indexOf(_.value.toString());
            //document.getElementById("value-slider"+_.id).innerHTML = _.value.toString() + "%";
          }
          _.colors = this.colors[i];
          i++;
        }else if(_.type == 2){
          _.value = !!_.value;
          _.colors = this.colors[i];
          i++;
        }

        /*
        _.value = [
          {
              "group": "value",
              "value": perc
          }
        ];

        _.options = {
          "resizable": true,
          "height": "100px",
          "width": "100%",
          "gauge": {
              "type": "semi",
              "status": "danger"
          },
          "color": {
            "scale": {
                "value": color
            },
           /* "gradient": {
              enabled: true,
              colors: '#edf'
            }
          },
          "toolbar": { "enabled": false }
        };

    });
*/

   /* this.actuators = this.actuators.filter(_=>_.id != 6 && _.id != 7);
    this.spinner.hide();*/
    this.showroomService.getListActuators().subscribe((_) => {
      console.log(_);
      this.actuators = _.data;
      var i = 0;
      this.actuators = this.actuators.filter(_=>_.id != 6 && _.id != 7 && _.id != 11 && _.id != 12);
      this.actuators.filter(_ => {
        if(_.id != 6 && _.id != 7 && _.id != 11 && _.id != 12){
          _.colors = "";
          if(_.type != 2){
            if(_.type==3){
              _.value = _.value;
              //document.getElementById("value-slider"+_.id).innerHTML = _.value.toString() + "%";
            }else if(_.type==5){
              //var array = _.stepOptions.split(",");
              //_.value =array.indexOf(_.value.toString());
              //document.getElementById("value-slider"+_.id).innerHTML = _.value.toString() + "%";
            }
            _.colors = this.colors[i];
            i++;

            if(_.maxLimit > 0){
              _.value =(_.value * 100) / _.maxLimit;
            }

          }else if(_.type == 2){
            _.value = !!_.value;
            _.colors = this.colors[i];
            i++;
          }

          if(_.colors != ""){
            _.color = _.colors[1];
          }

        }
      });
      /*var start = parseInt(this.actuators.filter(_ => _.id == 5)[0].value);
      var stop = parseInt(this.actuators.filter(_ => _.id == 6)[0].value);
      if(start==1 && stop==0){ start = 0; }
      this.stopButton = stop;
      this.startButton = start; */
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
    });
    this.spinner.hide();
  }

  changeIcon(){
    this.showPanel = true;
  }

  filter(){
    let dialogRef = this.dialog.open(ModalIotFilterComponent, {
      data: {
          title: AppConstants.TitleModal.REGISTER_TITLE_USER_MODAL,
          type: AppConstants.TypeModal.REGISTER,
          operation: AppConstants.OperationType.ADD,
          optionFilter: this.optionFilter
      },
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.optionFilter = response.optionFilter;
        this.showroomService.setPause(this.optionFilter);
        this.getListSensors();
      }
    });
  }

  closeModal(){
    this.showPanel = false;
  }

}
